'use client';

import React, { createContext, useContext, useState } from 'react';

interface ModalContextType {
  modalStates: Map<string, { isOpen: boolean; title?: string; data?: any }>;
  setModalState: (modalId: string, isOpen: boolean, title?: string, data?: any) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function ModalProvider({ children }: { children: React.ReactNode }) {
  const [modalStates, setModalStates] = useState<
    Map<string, { isOpen: boolean; title?: string; data?: any }>
  >(new Map());

  const setModalState = (
    modalId: string,
    isOpen: boolean,
    title?: string,
    data?: any
  ) => {
    setModalStates((prev) => {
      const newMap = new Map(prev);
      newMap.set(modalId, { isOpen, title, data });
      return newMap;
    });
  };

  return (
    <ModalContext.Provider value={{ modalStates, setModalState }}>
      {children}
    </ModalContext.Provider>
  );
}

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
